import axios from "axios";
import { useAuthStore } from "../Stores/AuthStore";
import env from "../config/env";

export const API_URL = env.PUBLIC_API_URL;

export const publicApi = axios.create({
  baseURL: API_URL,
  // timeout: 1000,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const authenticatedApi = axios.create({
  baseURL: API_URL,
  // timeout: 1000,
  headers: {
    'Content-Type': 'application/json',
  },
});
authenticatedApi.interceptors.request.use((config) => {
  const { access_token } = useAuthStore.getState();
  if (access_token) {
    config.headers['Authorization'] = `Bearer ${access_token}`;
  }
  return config;
});

// Intercepteur de réponse pour gérer l'expiration du token
authenticatedApi.interceptors.response.use(
  (response) => response,
  (error) => {
    // Si le token est expiré ou invalide (401), on déconnecte et redirige
    if (error.response?.status === 401) {
      console.log('[Interceptor] 401 detected, logging out with reason: expired');
      useAuthStore.getState().logout();
      // Redirect to login with expired error param
      window.location.href = '/?error=expired';
    }
    return Promise.reject(error);
  }
);